import {Navigate, Route, Routes} from "react-router-dom";
import SignIn from "Pages/SignIn";
import RequireAuthentication from "Components/RequireAuthentication";
import RedirectIfLoggedIn from "Components/RedirectIfLoggedIn";
import UserRoutes from "Pages/Users/UserRoutes";
import ResetPassword from "Pages/ResetPassword";
import AuthActions from "Pages/AuthActions";
import CustomerRoutes from "Pages/Customers/CustomerRoutes";
import ProjectRoutes from "Pages/Projects/ProjectRoutes";
import PartnerRoutes from "Pages/Partners/PartnerRoutes";
import OrderRoutes from "Pages/Orders/OrderRoutes";
import PrintRoutes from "Pages/Prints/PrintRoutes";
import ProductRoutes from "Pages/Products/ProductRoutes";
import DesignRoutes from "./Designs/DesignRoutes";
import BIRoutes from "./BI/BIRoutes";
import SideMenuLayout from "Layouts/SideMenuLayout";
import TagRoutes from "./Tags/TagRoutes";
import SettlementRoutes from "./Settlements/SettlementRoutes";
import {useUserContext} from "../Providers/UserContextProvider";
import {canAccess} from "../Utils/CanAccess";
import moment from "moment";

const ApplicationRoutes = () => {

    return (
        <Routes>

            <Route path={"/signin"} element={
                <RedirectIfLoggedIn>
                    <SignIn/>
                </RedirectIfLoggedIn>
            }/>

            <Route path={"/resetpassword"} element={
                <RedirectIfLoggedIn>
                    <ResetPassword/>
                </RedirectIfLoggedIn>
            }/>

            <Route path={"/auth/actions"} element={
                <RedirectIfLoggedIn>
                    <AuthActions/>
                </RedirectIfLoggedIn>
            }/>

            <Route path={"*"} element={
                <RequireAuthentication>
                    <SideMenuLayout>
                        <SignedInRoutes/>
                    </SideMenuLayout>
                </RequireAuthentication>
            }>
            </Route>
        </Routes>
    )
}

const SignedInRoutes = () => {

    const {user} = useUserContext();
    
    return (
            <Routes>
                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/orders/*`} element={
                        <OrderRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/users/*`} element={
                        <UserRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/bi/*`} element={
                        <BIRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/customers/*`} element={
                        <CustomerRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/projects/*`} element={
                        <ProjectRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/products/*`} element={
                        <ProductRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/designs/*`} element={
                        <DesignRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/prints/*`} element={
                        <PrintRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/tags/*`} element={
                        <TagRoutes/>
                    }/>
                )}

                {canAccess(user.permissions, 'Admin') && (
                    <Route path={`/partners/*`} element={
                        <PartnerRoutes/>
                    }/>
                )}

                <Route path={`/settlements/*`} element={
                    <SettlementRoutes/>
                }/>

                {canAccess(user.permissions, 'Admin') ? (
                    <Route path={"*"} element={<Navigate to={"/orders?page=0&status=Open&reverseTagSearch=false"}/>}/>
                ) : (
                    <Route path={"*"} element={<Navigate to={`/settlements/settlementResult?from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`}/>}/>
                )}
            </Routes>
    )
}

export default ApplicationRoutes
